import HttpService from "./http.service";

const endpoint = "/empresas";

class EmpresasService {
  list = async () =>
    await HttpService.get(
      `${endpoint}?limit=-1&sortBy=razaoSocial&sortOrder=1`
    );

  paginate = async (page = 0, limit = 25, sortStr = null, filterStr = null) =>
    await HttpService.get(
      `${endpoint}?page=${page}&limit=${limit}${sortStr || ""}${
        filterStr || ""
      }`
    );

  get = async (id) => await HttpService.get(`${endpoint}/${id}`);

  create = async (data) => await HttpService.post(endpoint, data);

  update = async (id, data) => await HttpService.put(`${endpoint}/${id}`, data);

  delete = async (id) => await HttpService.delete(`${endpoint}/${id}`);
}

export default new EmpresasService();
